module.exports = {"420821100":"新市镇","420821101":"永兴镇","420821102":"曹武镇","420821103":"罗店镇","420821104":"宋河镇","420821105":"坪坝镇","420821106":"三阳镇","420821107":"绿林镇","420821108":"杨集镇","420821109":"孙桥镇","420821110":"石龙镇","420821111":"永漋镇","420821112":"雁门口镇","420821113":"钱场镇","420821170":"开发区（镇）","420821449":"温泉新区","420821450":"太子山","420821451":"罗汉寺","420821452":"长滩","420821453":"何集","420821455":"易家岭","420821456":"屈家岭经济开发区","420821598":"原种场镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420821.json
// module id = 1603
// module chunks = 0